<div class="sidebar">
  <app-notification-sidebar #_notificationSidebarComponent></app-notification-sidebar>
</div>
